import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/site/Logo";

const links = [
  { to: "/how-it-works", label: "How It Works" },
  { to: "/use-cases", label: "Use Cases" },
  { to: "/privacy", label: "Privacy" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#090A0F]/70 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.to.slice(1)}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${
                  isActive ? "text-[#FF453A]" : "text-[#9BA1B0] hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/early-access"
            data-testid="nav-early-access-btn"
            className="rounded-full bg-[#FF453A] hover:bg-[#FF6961] transition-colors text-white text-sm font-semibold px-5 py-2.5 glow-red"
          >
            Get Early Access
          </Link>
        </nav>
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#090A0F]/95 backdrop-blur-xl px-5 py-4 flex flex-col gap-4">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="text-[#9BA1B0] hover:text-white text-base font-medium transition-colors"
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/early-access"
            onClick={() => setOpen(false)}
            data-testid="mobile-early-access-btn"
            className="rounded-full bg-[#FF453A] text-white text-center font-semibold px-5 py-3"
          >
            Get Early Access
          </Link>
        </div>
      )}
    </header>
  );
}
